import { alpha } from '@mui/material/styles'

// Shared table style props to keep surfaces transparent and consistent across MRT/native tables
export const createTableStyles = (theme) => ({
  muiTablePaperProps: {
    sx: {
      backgroundColor: 'transparent',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: 0,
    },
    elevation: 0,
  },
  muiTableContainerProps: {
    sx: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'auto',
      maxHeight: '100%',
      minHeight: 0,
      backgroundColor: 'transparent',
      width: '100%',
    },
  },
  muiTopToolbarProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiBottomToolbarProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTableHeadCellProps: {
    sx: { backgroundColor:alpha(theme.palette.table.head,0.5) },
  },
  muiTableFooterCellProps: {
    sx: { backgroundColor:alpha(theme.palette.table.head,0.5) },
  },
  muiTableBodyCellProps: {
    sx: { backgroundColor: 'inherit' },
  },
  muiTableBodyRowProps: {
    sx: {
      backgroundColor: alpha(theme.palette.table.row, theme.palette.mode === 'dark' ? 0.1 : 0.1),
      '&:hover': {
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.mode === 'dark' ? 0.1 : 0.35),
      },
    },
  },
})

